import Head from "next/head";
import Variables from "../../variables/variables.json";

import Index from "./_index";
import Kontakt from "./kontakt/_kontakt";
import Deklaracja from "./deklaracja-dostepnosci/_deklaracja";
import MapaStrony from "./mapa-strony/_mapastrony";

import Transportowe from "./podatek-od-srodkow-transportowych/_transportowe";
import Nieruchomosci from "./podatek-od-nieruchomosci/_nieruchomosci";
import Rolny from "./podatek-rolny/_rolny";
import Lesny from "./podatek-lesny/_lesny";
import Odpadykomunalne from "./oplata-za-gospodarowanie-odpadami-komunalnymi/_odpadykomunalne";

import Custom404 from "../../pages/404";
import Password from "../Password";

export default function PremiumLayout(props) {
  let Miasto = props.Miasto;
  let Podatek = props.Podatek;
  let RouterRedirect;

  let ComponentShow;

  if (Podatek == "index") {
    RouterRedirect = "/";
    ComponentShow = Index;
  }
  if (Podatek == "kontakt") {
    RouterRedirect = "/kontakt/";
    ComponentShow = Kontakt;
  }
  if (Podatek == "deklaracja") {
    RouterRedirect = "/deklaracja-dostepnosci/";
    ComponentShow = Deklaracja;
  }
  if (Podatek == "mapastrony") {
    RouterRedirect = "/mapa-strony/";
    ComponentShow = MapaStrony;
  }
  if (Podatek == "transportowe") {
    RouterRedirect = "/podatek-od-srodkow-transportowych/";
    ComponentShow = Transportowe;
  }
  if (Podatek == "nieruchomosci") {
    RouterRedirect = "/podatek-od-nieruchomosci/";
    ComponentShow = Nieruchomosci;
  }
  if (Podatek == "rolny") {
    RouterRedirect = "/podatek-rolny/";
    ComponentShow = Rolny;
  }
  if (Podatek == "lesny") {
    RouterRedirect = "/podatek-lesny/";
    ComponentShow = Lesny;
  }
  if (Podatek == "odpadykomunalne") {
    RouterRedirect = "/oplata-za-gospodarowanie-odpadami-komunalnymi/";
    ComponentShow = Odpadykomunalne;
  }

  return Variables.miasta[Miasto].pages.includes(Podatek) ? (
    <>
      {Variables.miasta[Miasto].password ? (
        <Password>
          <ComponentShow miasto={Miasto} podatek={Podatek} />
        </Password>
      ) : (
        <>
          <Head>
            <link
              rel="canonical"
              href={
                "https://przyjazne-deklaracje.pl/" +
                Variables.miasta[Miasto].name.url +
                RouterRedirect
              }
            />
          </Head>
          <ComponentShow miasto={Miasto} podatek={Podatek} />
        </>
      )}
    </>
  ) : (
    <Custom404 />
  );
}
